module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/flow_01_sp-7c1edefd9caf613e3c4fe4ce207b4f8d.png";